<!-- Segment and company-size lists (E2 RF-09). Hyper card, badges and form controls. -->
<page-heading
  [title]="'kanban.crmLists.title' | translate"
  [description]="'kanban.crmLists.subtitle' | translate"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        @if (loading) {
          <div class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">{{ 'kanban.crmLists.loading' | translate }}</span>
            </div>
          </div>
        } @else {
          <div class="d-flex justify-content-end mb-3">
            <button class="btn btn-primary" (click)="save()" [disabled]="saving">
              @if (saving) {
                <span class="spinner-border spinner-border-sm me-1" role="status"></span>
              }
              {{ 'kanban.crmLists.save' | translate }}
            </button>
          </div>

          <div class="row">
            @for (list of [{ key: 'segments', label: 'kanban.crmLists.segments' }, { key: 'employeeBands', label: 'kanban.crmLists.employeeBands' }]; track list.key) {
              <div class="col-md-6 mb-4">
                <h4 class="header-title">{{ list.label | translate }}</h4>

                <div class="input-group mb-2">
                  <input
                    #valueInput
                    type="text"
                    class="form-control"
                    maxlength="60"
                    [placeholder]="'kanban.crmLists.addPlaceholder' | translate"
                    (keydown.enter)="add($any(list.key), valueInput); $event.preventDefault()"
                  />
                  <button class="btn btn-soft-primary" type="button" (click)="add($any(list.key), valueInput)">
                    <i class="ri-add-line"></i> {{ 'kanban.crmLists.add' | translate }}
                  </button>
                </div>

                <div class="d-flex flex-wrap gap-1">
                  @for (value of lists[$any(list.key)]; track value) {
                    <span class="badge bg-soft-secondary text-secondary font-13 d-inline-flex align-items-center gap-1">
                      {{ value }}
                      <a href="javascript:void(0);" class="text-secondary" (click)="remove($any(list.key), value)" [attr.aria-label]="'kanban.leadModal.removeContact' | translate">
                        <i class="ri-close-line"></i>
                      </a>
                    </span>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
